var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2325 4949 c-221 -21 -493 -92 -714 -186 -551 -235 -1015 -696 -1250 -1245 -393 -915 -196 -1954 504 -2653 937 -938 2455 -938 3390 -1 938 940 938 2451 0 3392 -505 507 -1211 760 -1930 693z m1345 -1470 c67 -35 108 -78 142 -149 34 -69 32 -197 -4 -266 -16 -30 -262 -320 -613 -722 -540 -617 -592 -673 -649 -703 -55 -30 -69 -33 -146 -34 -68 0 -94 5 -130 23 -25 12 -241 179 -482 371 l-436 350 -34 68 c-29 60 -33 77 -33 148 0 72 3 86 34 143 60 110 153 166 276 165 118 -1 149 -19 449 -258 148 -119 280 -218 292 -221 12 -3 33 0 47 8 13 7 221 238 461 513 241 275 458 516 484 537 65 52 122 69 209 64 57 -4 85 -11 133 -37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.9d63ec6b75e514ef93c0b92944906a42.svg";
export { ForwardRef as ReactComponent };